<ng-container *ngIf="concertGroupeds$.value?.length; else noConcertTmp">
  <div class="container concert-grouped-wrapper">
    <div
      *ngFor="let concertGrouped of concertGroupeds$.value"
      class="concert-grouped-item"
      [routerLink]="['/grouped-concert/', concertGrouped.GROUPSEOURL]"
    >
      <img
        [src]="
          concertGrouped.GROUPIMAGEURL
            ? concertGrouped.GROUPIMAGEURL
            : 'assets/images/ticket.png'
        "
        [alt]="concertGrouped.GROUPNAME"
      />
      <h2 class="concert-grouped-title">{{ concertGrouped.GROUPNAME }}</h2>
    </div>
  </div>
</ng-container>
<ng-template #noConcertTmp>
  <div>
    <div class="container" style="padding: 10%">
      <div class="row dialog-glass-card" style="width: 90%; margin: auto">
        <div class="col-md-6" style="display: flex; justify-content: center">
          <img src="../../../../../assets/images/ticket.png" alt="ticket" />
        </div>
        <div
          class="col-md-6"
          style="display: flex; flex-direction: column; margin: auto"
        >
          <div style="font-size: 1.5rem; color: #f7c179; padding-bottom: 25px">
            {{ "NO_CONCERT_TEXT_1" | translate | async }}
          </div>
          <div style="font-size: 1rem; padding-bottom: 25px">
            {{ "NO_CONCERT_TEXT_2" | translate | async }}
          </div>
          <div style="font-size: 1rem; padding-bottom: 25px">
            {{ "NO_CONCERT_TEXT_3" | translate | async }}
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
